import type { BookingSessionResponse } from '@massilia/queries'

import { Skeleton } from '@massilia/ui'

import { InstallmentTimeline } from './installment-timeline'

interface SessionInstallmentTimelineProps {
  /** Session en cours de chargement : affiche un skeleton à la place de la frise. */
  loading?: boolean
  session?: BookingSessionResponse
}

/**
 * Frise échéancier alimentée par la session de réservation. Rendue nulle quand la
 * session n'est pas éligible au paiement en plusieurs fois ou que les données
 * (acompte, date limite) manquent encore.
 */
export function SessionInstallmentTimeline({ loading, session }: SessionInstallmentTimelineProps) {
  if (loading) {
    return (
      <div aria-hidden className="mt-4 flex w-full flex-col gap-2">
        <Skeleton className="h-4 w-44" />
        <Skeleton className="h-4 w-full" />
        <Skeleton className="h-4 w-3/5" />
      </div>
    )
  }

  if (
    !session?.installmentInfo?.available ||
    session.installmentInfo.minimumDepositCents === null ||
    session.installmentInfo.minimumDepositCents === undefined ||
    !session.paymentDeadline
  ) {
    return null
  }

  return (
    <InstallmentTimeline
      balanceDeadline={session.paymentDeadline}
      departureDate={session.flightDetails.departureDate}
      depositDeadline={session.installmentInfo.depositDeadline}
      minimumDepositCents={session.installmentInfo.minimumDepositCents}
    />
  )
}
